import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import { hydrate } from "@/lib";
import type { Site } from "@/types";
import { fetchSite } from "./thunk";

export interface SiteState {
  site: Partial<Site>;
  status: "idle" | "fetching" | "saving";
  error: null | string;
}

const initialState: SiteState = {
  site: {},
  status: "idle",
  error: null
};

export const siteSlice = createSlice({
  name: "site",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(hydrate, (state, action: PayloadAction<string>) => {
        return {
          ...state,
          ...action.payload[siteSlice.name]
        };
      })
      .addCase(fetchSite.pending, (state) => {
        state.status = "fetching";
      })
      .addCase(fetchSite.fulfilled, (state, action) => {
        state.status = "idle";
        state.site = action.payload;
      })
      .addCase(fetchSite.rejected, (state, action) => {
        state.status = "idle";
        state.error = action.error.message;
      });
  }
});
